import { Scale } from '@antv/scale';
export { Scale };